import { NeuroMessage, useDispatch, useProduct } from '@ignitesales/neuro-application/src/neuro-guide';
import { useNeuroMessages } from '@ignitesales/neuro-application/src/neuro-guide/components/MessageContext';
import { Modal } from '@ignitesales/neuro-application/src/neuro-ui/index';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import ReactSVG from 'react-svg';
import { productSelected } from '../../actions/commerce-business-branch-actions.mjs';

const ProductModal = ({ className, closeBtn, isOpen, onClose, product, isSubmittedProduct, initialActiveTab = 'features' }) => {
  const messageContext = useNeuroMessages();
  const classes = classnames(className, 'productModal');
  const {
    description,
    disclosures,
    descriptionAbbreviated,
    features,
    name,
    url,
    onProductActionClick,
    onSelectClick,
    isSelected
  } = useProduct(product);
  const cssBEM = 'productModal';
  const dispatch = useDispatch();
  const shouldDisplayDescriptionAbbreviated = messageContext.getMessage(`${product.id}.descriptionAbbreviatedOnModal`) || null;

  const [activeTab, setActiveTab] = useState(initialActiveTab);

  const excludeInterestedNow = [
    2720
  ]

  const shouldRenderInterestedNow = () => {
    return !excludeInterestedNow.includes(product.id);
  }

  useEffect(() => {
    setActiveTab(initialActiveTab);
  }, [initialActiveTab]);

  const renderProductFeatures = () => {
    return features.length > 0 &&
      <div className={`${cssBEM}__features`}>
        {product.addOns.length === 0 && <NeuroMessage id='products.features.title' tagName='div' className={`${cssBEM}__features--title`} />}
        <ul>{features.map((f, i) => <li key={i}>{f}</li>)}</ul>
      </div>
  };

  const renderProductAddons = () => {
    return product.addOns && product.addOns.length > 0 &&
      <div className={`${cssBEM}__addOns-container`}>
        <div>
          <ul className={`${cssBEM}__addOns-list`}>
            {product.addOns.map((ele, _id) => (

                <NeuroMessage id={`${ele.id}.name`} tagName={'li'} />
            )
            ).slice(0, product.addOns.length)}
          </ul>
        </div>

        <div className="enrollment-qr-code">
          <NeuroMessage id='summary.enrollmentQRCode.title' tagName='h4' />
          <img src="/classpath/assets/images/enrollment-qr-code.jpg" alt="enrollment-qr-code" />
        </div>
      </div>
  };

  const onProductClick = (productId) => {
    onProductActionClick({
      actionName: 'productApplyClicked',
    });
    const productUrl = messageContext.getMessage(`${productId}.url`);
    window.open(productUrl, "_blank");
  }

  const interestedIcon = isSelected ?  "fa fa-check" : "fa fa-plus-square-o"

  const onSelectHandler = () => {
    onSelectClick();
    dispatch(productSelected());
  }

  return (
    <Modal
      show={isOpen}
      className={classes}
      onClose={onClose}
      closeBtn={closeBtn}
      nodeId="root"
    >
      <div className={`${cssBEM}__container`}>
        <img src={`/classpath/assets/images/${product.groupType}.png`} alt={product.name} />
        <div className={`${cssBEM}__productContainer`}>
          <div className={`${cssBEM}__group`}>
            <h3><NeuroMessage id={`${product.groupType}`} /></h3>
          </div>
          <div className={`${cssBEM}__header`}>
            <h2><NeuroMessage id={`${product.id}.name`} /></h2>
          </div>
          <div className={`${cssBEM}__description`}>
            <p>{!!shouldDisplayDescriptionAbbreviated ? descriptionAbbreviated : description}</p>
          </div>
          {product.addOns && product.addOns.length > 0 ? (
            <div className={`${cssBEM}__tabs`}>
              <button onClick={() => setActiveTab('features')} className={activeTab === 'features' ? 'active' : ''}>
                Why this product?
              </button>
              <button onClick={() => setActiveTab('addons')} className={activeTab === 'addons' ? 'active' : ''}>
                Services and Products included
              </button>
            </div>
          ) : null}
          <div className={`${cssBEM}__sections`}>
            {(!product.addOns || product.addOns.length === 0 || activeTab === 'features') && renderProductFeatures()}
            {activeTab === 'addons' && renderProductAddons()}
          </div>
          <div className={`${cssBEM}__container__cta`}>
            <button className="btn" onClick={() => onProductClick(product.id)}><NeuroMessage id={'products.seeMore'} tagName="div" className="seeMore" />
              <ReactSVG src="/classpath/assets/images/icons/arrow_forward.svg" />
            </button>
            {shouldRenderInterestedNow() && (
              <button className={`btn ${isSelected ? 'selected' : 'unselected'}`} onClick={onSelectHandler} disabled={isSubmittedProduct}><NeuroMessage id={isSelected ? 'products.interested' : 'products.interestedNow'} />
                <i className={interestedIcon}></i>
              </button>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};

ProductModal.propTypes = {
  className: PropTypes.string,
  closeBtn: PropTypes.any,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  initialActiveTab: PropTypes.string,
};

export default ProductModal;
